import { BoostedFarm, ENativeAsset, FraxFarm, VestaFarm } from '~config/types';

export const CURVE_VST_POOL_LINK = 'https://arbitrum.curve.fi/factory/19';

export const TOKEN_BUY_LINKS = {
  [ENativeAsset.VST]: 'https://arbitrum.curve.fi/factory/19/',
  [FraxFarm.VST_FRAX_GAUGE]: 'https://arbitrum.curve.fi/factory/19/deposit',
  [VestaFarm['VST-FRAX']]: 'https://arbitrum.curve.fi/factory/19/',
  [BoostedFarm['VST-USDC']]: 'https://z0r.de/1422',
  [VestaFarm['VSTA-ETH']]:
    'https://app.balancer.fi/#/arbitrum/pool/0xc61ff48f94d801c1ceface0289085197b5ec44f000020000000000000000004d',
};
